

import { put, call } from "redux-saga/effects";
import { performGetRequest } from "../../services/apiServices/AxiosUtils";
import { URLS } from "../../services/apiServices/service";



//-----------------------------------------------------------------------------------
export const authorsListData = function* auhtorsList(action) {
  yield put({type : "SHOW_LOADER"})
  
   try {
     
    const path = URLS.ABOUT + `?search=true&in_my_team=true`
    const res = yield call(performGetRequest, path);
    if (res !== undefined && res.data.status === "success") {
      yield action.successCallBack(res)
    } else if(res.data.status === "error"){
      yield put({type : "HIDE_LOADER"})
      }
  } catch (error) {
    yield put({type : "HIDE_LOADER"})
    }
};

//-----------------------------------------------------------------------------------

//-----------------------------------------------------------------------------------
export const testimonialsData = function* testimonialsList(action) {
    yield put({type : "SHOW_LOADER"})
    
     try {
       
      const path = URLS.TESTIMONIAL
      const res = yield call(performGetRequest, path);
      if (res !== undefined && res.data.status === "success") {
        yield action.successCallBack(res)
      } else if(res.data.status === "error"){
        yield put({type : "HIDE_LOADER"})
        }
    } catch (error) {
      yield put({type : "HIDE_LOADER"})
      }
  };
  
  //-----------------------------------------------------------------------------------

  export const getAuthorInfoData = function* getAuthorInfo(action) {
    yield put({type : "SHOW_LOADER"})
    
     try {
       
      const path = `${URLS.ABOUT.replace(/\/$/, '')}/${action.id}`;
      const res = yield call(performGetRequest, path);
      if (res !== undefined && res.data.status === "success") {
        yield action.successCallBack(res)
       
      } else if(res.data.status === "error"){
        yield put({type : "HIDE_LOADER"})
        }
    } catch (error) {
      yield put({type : "HIDE_LOADER"})
      }
  };
  
  //-----------------------------------------------------------------------------------


